import { useMemo } from 'react';
import useUIContext from '~/ui/use-ui-context.ts';

const useContextForLocation = location => {
	const { contexts } = useUIContext();
	const context = useMemo(() => contexts.find(({ routesMatcher }) => routesMatcher(location)), [contexts, location]);
	return context;
};

export default useContextForLocation;
